import React, { useState} from 'react';
import { Button, TextField, Checkbox, FormControlLabel, FormGroup, Box, Typography } from '@mui/material';
import { Link ,useParams} from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import axios from 'axios';
import { toast } from 'react-toastify';

const CreateItemAttributeForm = () => {
  const [formData, setFormData] = useState({
    name: ''
  }); 
  const { id } = useParams(); // Get the id from the URL

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/itemattribute/update/${id}`, formData);
      toast.success('Item Attribute updated successfully!');
      // Optionally redirect or clear form after successful submit
      setFormData({ name: '' }); // Reset form data if necessary
    } catch (error) {
      console.error(error);
      toast.error('Failed to update Item Attribute. Please try again.');
    }
  };

  return (
    <Box sx={{ maxWidth:{xs:"100%",md:'70%'}, margin:{xs:"0",md:'auto'}, padding:{xs:0,md:2}}}>
      <form onSubmit={handleSubmit}>
        <fieldset
          style={{
            border: '1px solid #ccc',
            padding: '18px',
            borderRadius: '8px',
            marginBottom: '20px'
          }}
        >
          <legend
            style={{
              padding: '8px',
              width: 'auto',
            //   marginBottom: '20px',
              background: '#3C7F10',
              color: '#fff',
              borderRadius: '8px',
            }}
          >
            Item Attributes
          </legend>

          <Box sx={{ marginBottom: 2,maxWidth:{xs:"100%",sm:"100%",md:"100%"},width:{xs:"100%"}}}>
            {/* Label above the input */}
            <Typography variant="subtitle1" sx={{ marginBottom: 1,fontWeight:'500' }}>
            Name*
            </Typography>
            <TextField
            //   label="Category Name"
              variant="outlined"
              fullWidth
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            className='input-field-cls'
            helperText="Insert name"   
            />
          </Box>
        </fieldset>
        <Box sx={{ display: 'flex',justifyContent:'center', gap: 2 }}>
            <Button variant="contained" sx={{bgcolor:"green",color:'#fff'}} type="submit">
            <SaveIcon sx={{pr:1}}/>
              Save
            </Button>
            <Link to="/brands" style={{ textDecoration: 'none' }}>
              <Button variant="contained" sx={{bgcolor:"transparent",color:'green',boxShadow:'unset'}}>
              <SettingsBackupRestoreIcon sx={{pr:1}}/> 
                Back
              </Button>
            </Link>
          </Box>
      </form>
    </Box>
  );
};

export default CreateItemAttributeForm;
    